import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetServiceUserDocument, GetServiceUserQuery, ServiceUserDetail } from '../generated/service-user';

export const useGetServiceUserQuery = (): [ServiceUserDetail | undefined, boolean] => {
  const [{ data, fetching }] = useSecureGraphqlQuery<GetServiceUserQuery>({
    query: GetServiceUserDocument,
  });
  const result = data?.getServiceUser ?? undefined;

  return [result, fetching];
};
